// Copyright (c) 2017 TrainHeroic LLC
// WorkoutSet schema

import { schema } from 'normalizr';
import workoutSetExerciseSchema from '../workoutSetExercise/schema';

const workoutSetSchema = new schema.Entity(
    'sets',
    {
        exercises: new schema.Array(workoutSetExerciseSchema)
    },
    {
        idAttribute: entity => entity.id,
        processStrategy: entity => {
            const item = { ...entity };
            item.exercises.sort((a, b) => {
                if (a.order < b.order) return -1;
                if (a.order > b.order) return 1;
                return 0;
            });
            return item;
        }
    }
);

export default workoutSetSchema;
